import CONSTANTS from './constants';
import egtnlUtil from './egtnl-util';

const eventList = [
    CONSTANTS.EDAP_EVENTS.BOOKING_REQUEST_SUCCEEDED,
    CONSTANTS.EDAP_EVENTS.BOOKING_REQUEST_SUBMITTED,
    CONSTANTS.EDAP_EVENTS.CHECKOUT_PRESENTED,
];
const eventEnum = {
    'checkout.presented': 'window.tC.event.checkoutPresented',
    'booking_request.succeeded': 'window.tC.event.bookingRequestSucceeded',
    'booking_request.submitted': 'window.tC.event.bookingRequestSubmitted',
};

const tcEventsList = {
    eventBasedTagTrigger(args) {
        const eventName = args[0];
        const eventData = args[1];
        const tcEventName = eventEnum[eventName];
        if (
            eventList.includes(eventName) &&
            egtnlUtil.isVrboTagCommanderIntegration() &&
            window &&
            window.tC &&
            window.tC.event &&
            tcEventName
        ) {
            if (eventName === CONSTANTS.EDAP_EVENTS.BOOKING_REQUEST_SUCCEEDED)
                window?.tC?.event?.bookingRequestSucceeded(
                    this,
                    this.getTagCommanderPayload(eventData)
                );
            else if (eventName === CONSTANTS.EDAP_EVENTS.CHECKOUT_PRESENTED)
                window?.tC?.event?.checkoutPresented(
                    this,
                    this.getTagCommanderPayload(eventData)
                );
            else
                window?.tC?.event?.bookingRequestSubmitted(
                    this,
                    this.getTagCommanderPayload(eventData)
                );
        }
    },

    getTagCommanderPayload(eventData) {
        const tagCommanderPayload = {
            edap_bidtarget: eventData?.bid_target ?? '',
            reservation_id: eventData?.reservation_id ?? '',
            booking_flow: eventData?.booking_flow ?? '',
            order_total: eventData?.ordertotal ?? '',
            listing_id: eventData?.listing_id ?? '',
            full_order_rental_rate: eventData?.fullorderrentalrate ?? '',
            edap_action_location: eventData?.action_location ?? '',
            edap_adult_count: eventData?.adult_count ?? '',
            edap_child_count: eventData?.child_count ?? '',
            edap_currency: eventData?.currency ?? '',
            edap_date_end: eventData?.date_end ?? '',
            edap_date_start: eventData?.date_start ?? '',
            edap_discount_applied: eventData?.discount_applied ?? '',
            edap_discount_label: eventData?.discount_label ?? '',
            edap_item4: eventData?.item4 ?? '',
            edap_loyalty_id: eventData?.loyalty_id ?? '',
            edap_partner_name: eventData?.partner_name ?? '',
            edap_payment_method: eventData?.payment_method ?? '',
            edap_payment_split: eventData?.payment_split ?? '',
            edap_payment_squash: eventData?.payment_squash ?? '',
            edap_platform_source: eventData?.platform_source ?? '',
            edap_trip_id: eventData?.trip_id ?? '',
            edap_vrbex: eventData?.vrbex ?? '',
            edap_cancellation_policy: eventData?.cancellation_policy ?? '',
            edap_unit_link: eventData?.unit_link ?? '',
            edap_with_pets: eventData?.with_pets ?? '',
            lodging_directory_id: eventData?.lodging_directory_id ?? '',
        };
        return tagCommanderPayload;
    },
};

export default tcEventsList;
